import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveAs } from 'file-saver';

import { RootState } from '../../modules';
import {
  ChangeOrder,
  ChangeOrderParams,
  getChangeOrderDetailAsync,
} from '../../modules/change-orders';
import { contractType1Enum } from '../../modules/contracts';
import PDFViewModal2 from '../../components/expenses/PDFViewModal2';
import PCCODetailComponent from '../../components/contracts/PCCODetailComponent';
import { Drawer } from 'antd';
import PCCOEditDrawer from './PCCOEditDrawer';

interface PCCODetailDrawerProps {
  config: any;
  visible: boolean;
  onClose: () => void;
}
function PCCODetailDrawer({ config, visible, onClose }: PCCODetailDrawerProps) {
  const [pdfFile, setPdfFile] = useState<any>();
  const [visibleEditlDrawer, setVisibleEditDrawer] = useState<boolean>(false);
  const primeContract = useSelector(
    (state: RootState) => state.contracts.contract.data,
  );
  const changeOrder: ChangeOrder = useSelector(
    (state: RootState) => state.changeOrders.changeOrder.data,
  ) as ChangeOrder;

  const dispatch = useDispatch();

  useEffect(() => {
    if (primeContract === null || config === null) return;
    const params: ChangeOrderParams = {
      enterpriseId: config.enterpriseId,
      projectId: config.projectId,
      contractId: '' + primeContract.id,
      changeOrderId: config.changeOrderId,
      contractType1: contractType1Enum.PRIME_CONTRACT,
    };
    dispatch(getChangeOrderDetailAsync.request(params));
  }, [dispatch, config, primeContract]);

  const moveToEditPage = () => {
    setVisibleEditDrawer(true);
  };

  const _downloadPdf = () => {
    saveAs(pdfFile.url, `${pdfFile.name}`);
  };

  const openPdfFile = (file: any) => {
    setPdfFile(file);
  };

  const onCloseEditDrawer = () => setVisibleEditDrawer(false);

  return (
    <>
      {changeOrder && config && (
        <Drawer
          width={800}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
        >
          {visible && (
            <PCCODetailComponent
              enterpriseId={config.enterpriseId}
              projectId={config.projectId}
              data={changeOrder}
              moveToEditPage={moveToEditPage}
              openPdfFile={openPdfFile}
            />
          )}
        </Drawer>
      )}
      {pdfFile && (
        <PDFViewModal2
          visible={!!pdfFile}
          url={pdfFile.url}
          onCancel={() => setPdfFile(null)}
          onDownload={_downloadPdf}
        />
      )}
      {
        <PCCOEditDrawer
          config={config}
          visible={visibleEditlDrawer}
          onClose={onCloseEditDrawer}
        />
      }
    </>
  );
}

export default PCCODetailDrawer;
